module.exports = __webpack_public_path__ + "static/media/ChrisSlide.29dd7178.jpg";